/* eslint-disable no-param-reassign */
import Sonda from "@gcloud-npm/bit.utils.front-sonda";
import { createSondaContext } from "./contextUtils";
/* eslint-disable radix */
export function splitAtIndex(value, index) {
  return [value.substring(0, index), value.substring(index)];
}
export const addMediaQuery = (selector, styleStr, kind = "nodevice") => {
  let css = "";
  // 1) deciding media query
  switch (kind) {
    case "pc":
      css = `${css}@media screen and (min-width: 1260px){`;
      break;
    case "mobile":
      css = `${css}@media screen and (min-width: 0px) and (max-width: 768px) {`;
      break;
    case "mobileWhenNoTablet":
      css = `${css}@media screen and (min-width: 0px) and (max-width: 1260px) {`;
      break;
    case "nodevice":
      css = "";
      break;
    case "tablet":
    default:
      css = `${css}@media screen and (min-width: 768px) and (max-width: 1260px) {`;
      break;
  }
  // appending instructions
  css += `${selector} {${styleStr}}${kind === "nodevice" ? "{" : ""}`;
  css += "}";

  const head = document.head || document.getElementsByTagName("head")[0];
  const style = document.createElement("style");

  style.type = "text/css";
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
  head.appendChild(style);
};

/* it depends on full or container width */
/* it is important, know how pictures we have */
export const bannerBuildBGImg = (currentBGImg, idBanner, div2Fit, bgColor) => {
  /* Adding css rules for background image media queries */
  if (div2Fit === "container") {
    div2Fit = " .mainContainer";
  } else {
    div2Fit = "";
  }
  const node2AplyBG = `${idBanner}${div2Fit}`;

  /* BACKGROUNDS AND SHADES LIMIT */
  if (currentBGImg && currentBGImg.picMobile) {
    const deviceToAttach = !currentBGImg.picTablet
      ? "mobileWhenNoTablet"
      : "mobile";
    const { picMobile } = currentBGImg;
    const { position, size, src } = picMobile;
    // esta imagen al ser en movil si el div2Fit
    // es container ni mijita tiene que ser a full
    const node2AplyBGOnMobile = `${idBanner}`;
    // cuando es full pic se deja una imagen en lugar de una iamgen de fondo

    const bgImage = `url(${src})`;

    addMediaQuery(
      `#${node2AplyBGOnMobile}`,
      `background-image: ${bgImage};
        background-size: ${size};
        background-position: ${position};`,
      deviceToAttach
    );
  }
  if (currentBGImg && currentBGImg.picTablet) {
    const { picTablet } = currentBGImg;
    const { position, size, src } = picTablet;
    const bgImage = `url(${src})`;

    addMediaQuery(
      `#${node2AplyBG}`,
      `background-image: ${bgImage};
      background-size: ${size};
      background-position: ${position};
      background-repeat: no-repeat;`,
      "tablet"
    );
  }

  if (currentBGImg && currentBGImg.picDesktop) {
    const { picDesktop } = currentBGImg;
    const { position, size, src } = picDesktop;

    const bgImage = `url(${src})`;
    addMediaQuery(
      `#${node2AplyBG}`,
      `background-image: ${bgImage};
      background-size: ${size};
       background-position: ${position};`,
      "pc"
    );
    // }
  }

  /* SET DEFAULT BACKGROUND */
  if (bgColor) {
    addMediaQuery(`#${idBanner}`, `background-color: ${bgColor}`, "no");
  }
};

export const generateBgAndProperties = (idBanner, components, layout) => {
  // Tratamiento fondo del banner
  let whereDiv2Fit = "";
  let cssbgColor = "";
  if (components && components["BgImage-1"]) {
    const currentBGImg = components["BgImage-1"];
    cssbgColor = `--${currentBGImg.bgColor}`;
    whereDiv2Fit = currentBGImg.div2Fit;
    bannerBuildBGImg(
      currentBGImg,
      idBanner,
      currentBGImg.div2Fit,
      currentBGImg.bgColor,
      layout
    );
  }
  return {
    whereDiv2Fit,
    cssbgColor,
  };
};

/**
 * Comprueba y desplaza el scroll hasta la zona referenciada
 * @param {Object} ref referencia en el DOM
 */
export const checkRefAndMove = (ref, delay) => {
  if (ref.current) {
    setTimeout(() => {
      ref.current.scrollIntoView({ block: "start", behavior: "smooth" });
    }, delay);
  }
};

export const giveRandomNumber = (min, max) => {
  return Math.floor(Math.random() * max) + min;
};

/**
 * Comprueba un array de objetos y devuelve uno aleatoriamente
 * en base al peso que se le haya asignado. Propiedad porcentaje
 * es necesaria, y al menos un elemento obviammente
 * @param {Array} multipleOptions array de objetos
 */
export const chooseOptionFromArray = (multipleOptions) => {
  try {
    if (multipleOptions.length === 1) {
      return multipleOptions[0];
    }
    const random = Math.random() * 100;
    let auxRandom = 0;
    let selectedOption = 0;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < multipleOptions.length; i++) {
      if (parseInt(multipleOptions[i].porcentaje) + auxRandom > random) {
        selectedOption = i;
        break;
      } else {
        // eslint-disable-next-line radix
        auxRandom += parseInt(multipleOptions[i].porcentaje);
      }
    }
    return multipleOptions[selectedOption];
  } catch (e) {
    return multipleOptions[0];
  }
};

export const getUrlParams = (url) => {
  if (!url.includes("?")) {
    return null;
  }

  const stringWithParams = url
    .slice(url.indexOf("?"), url.length)
    .replace("?", "");

  if (!stringWithParams) {
    return null;
  }

  const params = stringWithParams.split("&");

  return params.reduce((obj, eachParam) => {
    const paramSeparated = eachParam.split("=");
    const key = paramSeparated[0];
    const value = paramSeparated[1] || null;
    obj[key] = value;

    return obj;
  }, {});
};

export const getTelefonoFromProducts = (mobile, fijo) => {
  try {
    if (
      mobile &&
      mobile.datosLineasAbono &&
      mobile.datosLineasAbono.length > 0
    ) {
      return mobile.datosLineasAbono[0].num_telefono;
    }
    if (fijo && fijo.lineasFija && fijo.lineasFija.length > 0) {
      return fijo.lineasFija[0].numComPrim;
    }
    return "";
  } catch (error) {
    const context = createSondaContext("empresas");
    const sonda = new Sonda({
      processName: "getTelefonoFromProducts",
      context,
      filePath: "utils/common",
    });
    sonda.errorMessage({ error });
    return "";
  }
};

export const setDataDataToUser = (client, mobile, fijo) => {
  try {
    const datosUsuario = {
      nombre:
        (client && client.name) ||
        (client && client.adminName) ||
        (client && client.businessName) ||
        "",
      docNumber: (client && client.docNumber) || "",
      email: (client && client.email) || "",
      docTypeText:
        (client && client.docTypeText && client.docTypeText === "Pasaporte"
          ? "PASSPORT"
          : client.docTypeText) || "",
      telefono: getTelefonoFromProducts(mobile, fijo),
    };

    sessionStorage.setItem("datosUsuario", JSON.stringify(datosUsuario));
  } catch (error) {
    const context = createSondaContext("empresas");
    const sonda = new Sonda({
      processName: "setDataDataToUser",
      context,
      filePath: "utils/common",
    });
    sonda.errorMessage({ error });
    return null;
  }
};

export const getUrlWithoutFinalBar = (url) => {
  if (url[url.length - 1] === "/") {
    return url.slice(0, url.length - 1);
  }
  return url;
};

export const mergeConfigPage = (config) => {
  let result = config.default;
  if (window.location.pathname === "/") {
    if (config[getUrlWithoutFinalBar("/kit-digital")]) {
      result = config[getUrlWithoutFinalBar("/kit-digital")];
    }
  } else if (config[getUrlWithoutFinalBar(window.location.pathname)]) {
    result = config[getUrlWithoutFinalBar(window.location.pathname)];
  }
  return result;
};
